<div class="page-container">
    <div class="header-section">
        <div class="left">
            <app-page-close-button (closePage)="cancel()"></app-page-close-button>
            @if (isAdvancePayment) {
                <div class="title">Record Advance Payment</div>
            } @else {
                <div class="title">Record Payment</div>
            }
        </div>
        <div class="right" *ngIf="!viewMode">
            <button class="btn secondary_button" (click)="cancel()">Cancel</button>
            <button class="btn primary_button" (click)="saveForm()">Generate Receipt</button>
        </div>
    </div>

    <div class="body">
        <section class="customer-input card-layout">
            <form [formGroup]="paymentForm">
                <div class="payment-form customer-input">
                    <div class="form-row">
                        <div class="form-item">
                            <label class="required_field_label" for="paymentDate">Receipt Date</label>
                            <app-date-picker
                            [id]="'paymentDate'"
                            [type]="'datetime-local'"
                            [formControlName]="'paymentDate'"
                            [placeholder]="'Select Date'"
                            [required]="true">
                            </app-date-picker>
                            <div class="form_validation_error_new" [ngClass]="{'visible': paymentForm.get('paymentDate')?.invalid && paymentForm.get('paymentDate')?.touched}">
                                <small *ngIf="paymentForm.get('paymentDate')?.errors?.['required']">
                                    Receipt Date is required
                                </small>
                            </div>
                        </div>
                        <div class="form-item" *ngIf="!viewMode">
                            <label class="required_field_label" for="customer">Customer</label>
                            <app-autocomplete-dropdown
                                id="customer"
                                name="Customer"
                                formControlName="customer"
                                class = "autocomplete-dropdown"
                                [placeholder]="'Select'"
                                [apiUrl]="'v1/customers/list'"
                                [filterByKeys]="['NAME_CONTAINS']"
                                [limit]="10"
                                [orderBy]="{ name: 'asc' }"
                                [filterByKey]="'name'"
                                [bindLabel]="'name'"
                                [bindValue]="'id'"
                                [displayColumns]="[
                                    { key: 'name', header: 'Name' },
                                    { key: 'code', header: 'Code' },
                                ]"
                                [additionalFilters]="[
                                    {
                                        'name': 'IS_ACTIVE',
                                        'alias': 'active',
                                        'operator': 'EQ',
                                        'value': [true]
                                    }
                                ]"
                                [disable]="paymentForm.disabled"
                                (suggestionSelected)="handleValueChange(0, {controlName: 'customer', result: $event})"
                                (searchCleared)="customerSelectionCleared('customer')"
                                >
                            </app-autocomplete-dropdown>
                            <div class="form_validation_error_new" [ngClass]="{'visible': paymentForm.get('customer')?.invalid && paymentForm.get('customer')?.touched}">
                                <small *ngIf="paymentForm.get('customer')?.errors?.['required']">
                                    Customer is required
                                </small>
                            </div>
                        </div>

                        <div class="form-item" *ngIf = "!isAdvancePayment">
                            <label class="required_field_label" for="payingParty">Paying Party</label>
                            <app-autocomplete-dropdown
                                id="payingParty"
                                name="payingParty"
                                formControlName="payingParty"
                                class = "autocomplete-dropdown"
                                [placeholder]="'Select'"
                                [apiUrl]="'v1/customers/list'"
                                [filterByKeys]="['NAME_CONTAINS']"
                                [limit]="10"
                                [orderBy]="{ name: 'asc' }"
                                [filterByKey]="'name'"
                                [bindLabel]="'name'"
                                [bindValue]="'id'"
                                [additionalFilters]="[
                                    {
                                        'name': 'IS_ACTIVE',
                                        'alias': 'active',
                                        'operator': 'EQ',
                                        'value': [true]
                                    }
                                ]"
                                [displayColumns]="[
                                    { key: 'name', header: 'Name' },
                                    { key: 'code', header: 'Code' },
                                ]"
                                [disable]="paymentForm.disabled"
                                (suggestionSelected)="handleValueChange(0, {controlName: 'payingParty', result: $event})"
                                (searchCleared)="customerSelectionCleared('payingParty')"
                                >
                            </app-autocomplete-dropdown>
                            <div class="form_validation_error_new" [ngClass]="{'visible': paymentForm.get('payingParty')?.invalid && paymentForm.get('payingParty')?.touched}">
                                <small *ngIf="paymentForm.get('payingParty')?.errors?.['required']">
                                    Payment Party is required
                                </small>
                            </div>
                        </div>

                        <div class="form-item customer_stats" *ngIf="customerStats.length > 0">
                            <app-stats [stats]="customerStats"
                                [headerIconUrl]="'assets/icons/bank_note_icon.svg'"
                                [headerIconBgColor]="'#FEF0C7'"
                                [headerIconColor]="'#F79009'">
                            </app-stats>
                        </div>
                    </div>
                </div>
            </form>
        </section>

        <section *ngIf="!isAdvancePayment && invoiceList.length > 0" class="invoice-info-section">
            <div class="section-header"><span>Invoice Details</span></div>

            <app-editable-table
                #containerDetailsSection
                [tableHeaders]="tableHeaders"
                [tableData]="invoiceList"
                [disableTable]="viewMode"
                [showInputFieldsOnTh]="false"
                [allowSelection]="!viewMode"
                (selectedRowsSubject)="setSelectedInvoiceIds($event)"
            ></app-editable-table>

        </section>

        <section class="transactions-section">
            <div class="section-header"><span>Payment Details</span></div>

            <div class= "payment-details-container card-layout" *ngFor="let form of paymentFormList.controls; let i = index">

                <div class="payment-header-text">
                    <div class="section-title">Payment {{ (i + 1) }}</div>
                </div>

                <div class="divider"></div>

                <app-dynamic-form
                [formGroup]="form"
                [formConfig]="transactionFormConfig[i]"
                (onValueChange)="handleValueChange(i, $event)"
                >
                </app-dynamic-form>
            </div>

        </section>

        <section class="add-payment-section" *ngIf="!viewMode">
            <button class="btn add-payment-btn" (click)="addNewPayment()">
                <app-svg-icon class="image-icon"
                    [path]="'assets/icons/add_plus_icon.svg'"
                ></app-svg-icon>
                <span>Add Payment</span>
            </button>
        </section>

        <section class="file-upload-section">
            <app-file-upload *ngIf="!viewMode"
            [(files)]="selectedFiles"
            [allowedFileTypes]="allowedFileTypes"
            [multiFileUpload]="true"
            ></app-file-upload>

            <div class="payment-summary" *ngIf="!isAdvancePayment">
                <div class="summary-row">
                    <div class="summary-label">Amount Received</div>
                    <div class="summary-value">Rs. {{ totalAmountReceived }}</div>
                </div>
                <div class="summary-row">
                    <div class="summary-label">Amount used for payment</div>
                    <div class="summary-value">Rs. {{ amountUsedForPayment }}</div>
                </div>
                <div class="summary-row">
                    <div class="summary-label">Excess Amount</div>
                    <div class="summary-value">Rs. {{ excessAmount }}</div>
                </div>
            </div>
        </section>
    </div>
</div>
